// src/components/DesarrollosPage/DesarrollosPage.js
import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom'; // Import useNavigate
import './DesarrollosPage.scss'; // New SCSS file for this component
import {Trans} from "@lingui/react/macro"
import {t} from "@lingui/core/macro"
import { useLingui } from "@lingui/react"; 

const DesarrollosPage = () => {

    const { i18n } = useLingui(); // Still need this for document.title, not for content selection


    // Main descriptive content, written directly in JSX with Trans for translation
     const projectsIntro = (
        <>
            <p>
                <Trans>
                    Cosmic Shores desarrolla soluciones integrales para infraestructura espacial y territorial asociada, combinando planificación estratégica, ingeniería conceptual, análisis regulatorio y evaluación de impacto.
                </Trans>
            </p>
            <p><Trans>Actualmente, los desarrollos de Cosmic Shores se estructuran en las siguientes líneas principales:</Trans></p>

            <ol className="alpha">
            <li><Trans>Complejos y plataformas espaciales</Trans></li>
            <ul>
                <li><Trans>Planificación y diseño conceptual de espaciopuertos</Trans></li>
                <li><Trans>Estudios de localización y alternativas</Trans></li>
                <li><Trans>Integración territorial e intermodal</Trans></li>
                <li><Trans>Escalabilidad por fases</Trans></li>
            </ul>
            <li><Trans>Estudios estratégicos y de factibilidad</Trans></li>
                <ul>
                    <li><Trans>Análisis técnico-económico</Trans></li>
                    <li><Trans>Evaluación regulatoria y normativa internacional</Trans></li>
                    <li><Trans>Modelos de gobernanza y operación</Trans></li>
                    <li><Trans>Análisis de riesgos y sostenibilidad</Trans></li>
                </ul>
            <li><Trans>Innovación, tecnología y digitalización</Trans></li>
                <ul>
                    <li><Trans>Gemelos digitales</Trans></li>
                    <li><Trans>Simulación operacional</Trans></li>
                    <li><Trans>Sistemas de apoyo a la decisión</Trans></li>
                    <li><Trans>Integración de datos espaciales y territoriales</Trans></li>
                </ul>
            <li><Trans>Desarrollo de capacidades y ecosistema</Trans></li>
                <ul>
                    <li><Trans>Formación de talento</Trans></li>
                    <li><Trans>Articulación academia-industria-Estado</Trans></li>
                    <li><Trans>Transferencia de conocimiento</Trans></li>
                    <li><Trans>Acompañamiento institucional</Trans></li>
                </ul>
            </ol>        
            <p>
                <Trans>
                Cada una de estas líneas se encuentra en distintos niveles de madurez, abarcando desde fases conceptuales y estudios de factibilidad hasta propuestas avanzadas de implementación.
                </Trans>
            </p>
            <p>
                <Trans>
                Los desarrollos de Cosmic Shores se conciben como plataformas evolutivas, adaptables a distintos contextos regulatorios, territoriales y tecnológicos, acompañando el crecimiento sostenido y ordenado del sector espacial.
                </Trans>
            </p>
            <p>
                <Trans>A continuación se presentan ejemplos de desarrollos aplicados que ilustran estas capacidades.</Trans>
            </p>
        </>
    );


    // DEFINICIONES ROCHA
    const projectRochaTitle = t`Propuesta Conceptual de Spaceport en Rocha (Uruguay)`;
    const projectImageSrc = "rocha-spaceport-render.jpg"; // Path relative to public/images/projects/
    const projectImageCaption = t`Render vista aérea de la propuesta para el Spaceport de Rocha.`;
    const projectYoutubeId = "LOCgiFHgSVQ"; // Just the ID from the YouTube URL
    const projectoRocha = (
        <>
            <p>
                <Trans>
                El desarrollo conceptual de un spaceport en el departamento de Rocha representa un ejercicio integral de planificación orientado a explorar escenarios futuros para la infraestructura espacial en entornos ambientalmente sensibles.
                </Trans>
            </p>
            <p>
                <Trans>
                La propuesta integra criterios de funcionalidad técnica, sostenibilidad ambiental e inserción territorial, contemplando tanto las necesidades operativas como los componentes de vinculación con el entorno y la comunidad.
                </Trans>
            </p>
            <h3><Trans>Componentes principales considerados</Trans></h3>
            <ul>
                <li>
                    <strong><Trans>Plataformas de lanzamiento</Trans>:</strong> <Trans>Configuraciones flexibles acordes a distintos tipos de vehículos espaciales.</Trans>
                </li>
                <li>
                    <strong><Trans>Centro de Integración y Pruebas (AIT)</Trans>:</strong> <Trans>Infraestructura para ensamblaje, integración y verificación de sistemas.</Trans>
                </li>
                <li>
                    <strong><Trans>Zona de aterrizaje para vehículos reutilizables</Trans>:</strong> <Trans>Áreas especialmente adaptadas para operaciones de recuperación.</Trans>
                </li>
                <li>
                    <strong><Trans>Centro de visitantes y divulgación</Trans>:</strong> <Trans>Espacios orientados a educación, comunicación pública y difusión científica.</Trans>
                </li>
                <li>
                    <strong><Trans>Área de conservación ambiental</Trans>:</strong> <Trans>Integración con entornos naturales adyacentes, promoviendo criterios de protección y biodiversidad.</Trans>
                </li>
                <li>
                    <strong><Trans>Instalaciones de entrenamiento especializado</Trans>:</strong> <Trans>Infraestructura de simulación y preparación técnica.</Trans>
                </li>
                <li>
                    <strong><Trans>Infraestructura de apoyo y alojamiento</Trans>:</strong> <Trans>Soluciones de bajo impacto ambiental para soporte operativo y logístico.</Trans>
                </li>
            </ul>
            <p>
                <Trans>
                    El trabajo se desarrolló en etapas sucesivas. Un primer esquema conceptual permitió explorar criterios generales de localización, operación e integración territorial. A partir de ese ejercicio inicial, el desarrollo evolucionó hacia un segundo esquema de implantación, incorporando un mayor nivel de definición en la organización del sitio y en los contenidos relativos a las infraestructuras y funciones asociadas.
                </Trans>
            </p>
        </>
    );

    // Construct YouTube embed URL
    const youtubeEmbedUrl = `https://www.youtube.com/embed/${projectYoutubeId}?autoplay=0&modestbranding=1&rel=0`;
    const imageUrl = projectImageSrc ? `${process.env.PUBLIC_URL}/images/projects/${projectImageSrc}` : null;


  return (
        <div className='desarrollos-page-wrapper'>
            
            {/* INTRODUCCION */}
            <div className='project-content-container'>
                <h1 className='project-title'><Trans>Introducción</Trans></h1>
                <div className='project-description-block'>{projectsIntro}
                </div>
            </div>

            {/* ROCHA */}
            <div className='project-content-container'>
                <h1 className='project-title'>{projectRochaTitle}</h1>

            
                <div className='project-description-block'> {/* New div to wrap the description JSX */}
                    {projectoRocha}
                </div>

                {/* Optional Image with Caption */}
                {imageUrl && (
                    <div className='project-media-block'>
                        <div className='project-image-wrapper'>
                            <img src={imageUrl} alt={projectRochaTitle} className='project-image' />
                        </div>
                        {projectImageCaption && (
                            <p className='image-caption'>{projectImageCaption}</p>
                        )}
                    </div>
                )}

                {/* YouTube Video Embed */}
                {projectYoutubeId && (
                    <div className='project-media-block'>
                        <div className='youtube-embed-wrapper'>
                            <iframe
                                src={youtubeEmbedUrl}
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                                title={projectRochaTitle}
                            ></iframe>
                        </div>
                         {/* Optionally add a hardcoded video caption if needed */}
                         <p className='video-caption'><Trans>Video mostrando un render del proyecto Spaceport de Rocha.</Trans></p>
                    </div>
                )}
            <div className='project-description-block'><p><Trans>Este desarrollo se concibe como una plataforma conceptual adaptable, sujeta a evaluaciones técnicas, regulatorias y ambientales específicas. </Trans></p></div>
            </div>

            {/* ANÁLISIS DE NUEVOS EMPLAZAMIENTOS */}
            <div className='project-content-container'>
                <h1 className='project-title'><Trans>Análisis de nuevos emplazamientos sobre la costa Argentina</Trans></h1>
                <div className='project-description-block'>
                    <p>
                        <Trans>
                            En paralelo, Cosmic Shores se encuentra trabajando en estudios exploratorios para la identificación y evaluación de potenciales emplazamientos de infraestructura espacial a lo largo de la costa argentina. Estos análisis consideran, entre otros aspectos, variables geográficas, ambientales, operacionales, regulatorias y de integración territorial, con el objetivo de identificar alternativas viables para desarrollos futuros.
                        </Trans>
                    </p>
                    <p>
                        <Trans>Los estudios se orientan a:</Trans>
                    </p>
                    <ul>
                        <li><Trans>Evaluar condiciones técnicas y operativas preliminares.</Trans></li>
                        <li><Trans>Analizar compatibilidades ambientales y territoriales.</Trans></li>
                        <li><Trans>Identificar restricciones normativas y regulatorias.</Trans></li>
                        <li><Trans>Explorar modelos de desarrollo escalables y progresivos.</Trans></li>
                    </ul>
                    <p>
                        <Trans>Estos estudios se conciben como insumos preliminares para la toma de decisiones estratégicas, sujetos a profundización técnica, regulatoria y ambiental.</Trans>
                    </p>
                    <p>
                        <Trans>
                            Desde el punto de vista de la seguridad operacional y la definición de corredores de lanzamiento, los sectores más australes de la costa atlántica argentina presentan restricciones significativas. En dichas latitudes, las trayectorias nominales hacia órbitas polares, heliosincrónicas u otras órbitas de uso frecuente tienden a proyectarse sobre áreas sensibles del Atlántico Sur y, adicionalmente, implican mayores penalizaciones energéticas, afectando la eficiencia del lanzamiento, la capacidad de carga útil y la flexibilidad operativa.
                        </Trans>
                    </p>
                    <p>
                        <Trans>
                        En consecuencia, los análisis de emplazamiento priorizan tramos costeros que permitan orientar las trayectorias hacia mar abierto, optimizando los requerimientos energéticos, evitando el sobrevuelo de zonas no deseadas y facilitando el cumplimiento de criterios técnicos, regulatorios y geopolíticos.
                        </Trans>
                    </p>
                </div>
            </div>


            {/* ANÁLISIS DE EMPLAZAMIENTOS EXISTENTES */}
            <div className='project-content-container'>
                <h1 className='project-title'><Trans>Análisis de emplazamientos existentes para infraestructura espacial en Argentina</Trans></h1>
                <div className='project-description-block'>
                    <p>
                        <Trans>En este marco, Cosmic Shores se encuentra analizando emplazamientos históricos vinculados al desarrollo de capacidades de lanzamiento en la Argentina, incluyendo instalaciones asociadas a programas previos de ensayos y acceso al espacio. Estos análisis iniciales están orientados a evaluar su potencial puesta en valor, considerando criterios técnicos, operacionales, regulatorios y de integración territorial.</Trans>
                    </p>
                </div>
            </div>

        </div>
    );
};

export default DesarrollosPage;